<template>
  <div id="container">
    <!-- 还需要个属性来设置背景图片 -->
    <div class="company_img">
      <div class="company_info">
        <div>Company info</div>
        <span class="blue_line"></span>
      </div>
    </div>
    <div class="full_layout">
      <div class="company_message">
        <p>Card Hobby was established in March 2015.</p><br>

        <p>We are the leading third party trading service platform for sports trading cards, TCG cards and all kinds of film and TV culture
          IP cards in China.</p><br>

        <p>We have consistently been focusing on the development and operation of sports card trading, Internet trading platform and
          technology solutions.</p><br>

        <p>Aiming at creating a more convenient, secure, compliant and efficient trading environment for our users, Card Hobby has launched
          both Web Client and App.</p><br>

        <p>Meanwhile, Card Hobby has also established a long-term cooperative relationship with China UnionPay, Stripe and Paypal, in order
          to provide a more reliable trading environment for our users.</p><br>

        <p>Card Hobby is developed by Ssuper Technology INC. Our affiliates include Ssuper HongKong Technology Limited and Ssuper UK Technology Limited.</p>
        
      </div>
      <company-video class="companyvideo" />
      <div class="company_message">
        <p>The company's GMV has been continuously increasing since 2018, from 5 million RMB (nearly 700 thousand Dollars) per month to
          nearly 100 million RMB (nearly 14 million Dollars) per month with more than 250,000 users worldwide. (latest data from Aug 2022)
        </p>
      </div>
      <div class="analyse">
        <div class="text_content text_2014"></div>
        <div class="text_content text_2016"></div>
        <div class="text_content text_2018"></div>
        <div class="text_content text_2019"></div>
        <div class="text_content text_2020"></div>
        <div class="text_content text_2021"></div>
        <div class="text_content text_2022"></div>
      </div>
    </div>
  </div>
</template>

<script>
import CompanyVideo from "@/components/companyvideo";
export default {
  name: "companyinfo",
  components: { CompanyVideo },
  data() {
    return {};
  },
  created() {

  },
}
</script>

<style scoped>
.company_img {
  background: url(../../../static/images/company.png) no-repeat center;
  height: 280px;
  background-size: cover;
  display: flex;
  align-items: center;
}
.company_info {
  width: 1200px;
  margin: 0 auto;
  display: block;
}
.company_info > div {
  font-size: 48px;
  color: #fff;
}
.blue_line {
  width: 124px;
  height: 4px;
  background-color: #5f6dae;
  display: block;
  margin-top: 13px;
}
.company_message h3 {
  font-weight: normal;
  line-height: 1;
}
.company_message {
  font-size: 24px;
  margin: 32px 0;
}
.analyse {
  height: 1500px;
  background: url(../../../static/images/Milestones.png) no-repeat center;
  background-size: 100%;
  position: relative;
}
.text_content {
  width: 345px;
  position: absolute;
  transition:.6s;
}
.text_content:hover {
  transform: scale(1.05);
  transition:.6s;
}
.text_2014 {
  height: 111px;
  background: url(../../../static/images/2014.png) no-repeat center;
  background-size: 100%;
  left: 131px;
  top: 176px;
}
.text_2016 {
  height: 68px;
  background: url(../../../static/images/2016.png) no-repeat center;
  background-size: 100%;
  right: 144px;
  top: 281px;
}
.text_2018 {
  height: 142px;
  background: url(../../../static/images/2018.png) no-repeat center;
  background-size: 100%;
  left: 43px;
  top: 395px;
}
.text_2019 {
  height: 68px;
  background: url(../../../static/images/2019.png) no-repeat center;
  background-size: 100%;
  right: 232px;
  top: 561px;
}
.text_2020 {
  height: 164px;
  background: url(../../../static/images/2020.png) no-repeat center;
  background-size: 100%;
  right: 23px;
  top: 692px;
}
.text_2021 {
  height: 68px;
  background: url(../../../static/images/2021.png) no-repeat center;
  background-size: 100%;
  left: 285px;
  top: 852px;
}
.text_2022 {
  height: 138px;
  background: url(../../../static/images/2022.png) no-repeat center;
  background-size: 100%;
  left: 51px;
  top: 968px;
}
</style>


// WEBPACK FOOTER //
// src/pages/Company/companyinfo.vue